import { render, staticRenderFns } from "./Infographic7.vue?vue&type=template&id=2cf3ad37&scoped=true&"
import script from "./Infographic7.vue?vue&type=script&lang=js&"
export * from "./Infographic7.vue?vue&type=script&lang=js&"
import style0 from "./Infographic7.vue?vue&type=style&index=0&id=2cf3ad37&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2cf3ad37",
  null
  
)

export default component.exports